export function root(bid: string): string {
	return `/brands/${bid}/notifications`
}
